module.exports = __webpack_public_path__ + "img/analytics_mobile_e1ad6fd.webp";